export default __webpack_public_path__ + "static/media/loading-3.88daefd0.gif";